// 由 EB view/admin/src/router/modules/accounts.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const accountsRouter: RouteRecordRaw =
  {
    path: `${roterPre}/accounts`,
    name: 'accounts',
    meta: {
      icon: '',
      title: '财务'
    },
    alwaysShow: true,
    component: Layout,
    children: [
      {
        path: 'extract',
        name: 'AccountsExtract',
        meta: {
          title: '提现管理',
          noCache: true
        },
        component: () => import('@/views/accounts/extract/index.vue')
      },
      {
        path: 'bill',
        name: 'AccountsBill',
        meta: {
          title: '充值记录',
          noCache: true
        },
        component: () => import('@/views/accounts/bill/index.vue')
      },
      {
        path: 'capital',
        name: 'AccountsCapital',
        meta: {
          title: '资金记录',
          noCache: true
        },
        component: () => import('@/views/accounts/capital/index.vue')
      },
      {
        path: 'reconciliation',
        name: 'AccountsReconciliation',
        meta: {
          title: '财务对账',
          noCache: true
        },
        component: () => import('@/views/accounts/reconciliation/index.vue')
      },
      {
        path: 'statement',
        name: 'AccountsStatement',
        meta: {
          title: '平台账单',
          noCache: true
        },
        component: () => import('@/views/accounts/statement/index.vue')
      },
      {
        path: 'merchantBill',
        name: 'AccountsMerchantBill',
        meta: {
          title: '店铺账单',
          noCache: true
        },
        component: () => import('@/views/accounts/statement/merchantBill.vue')
      },
      {
        path: 'billDetails/:id',
        name: 'BillDetails',
        meta: {
          title: '店铺账单详情',
          noCache: true,
          activeMenu: '/accounts/merchantBill'
        },
        component: () => import('@/views/accounts/statement/merchantDetail.vue'),
        hidden: true
      },
      {
        path: 'reconciliation/order/:id/:type?',
        name: 'ReconciliationOrder',
        component: () => import('@/views/merchant/list/record.vue'),
        meta: {
          title: '查看订单',
          noCache: true,
          activeMenu: '/accounts/reconciliation'
        },
        hidden: true
      },
      {
        path: 'capitalFlow',
        name: 'AccountsCapitalFlow',
        meta: {
          title: '资金流水',
          noCache: true
        },
        component: () => import('@/views/accounts/capitalFlow/index.vue')
      },
      {
        path: 'transferRecord',
        name: 'AccountsTransferRecord',
        meta: {
          title: '转账记录',
          noCache: true
        },
        component: () => import('@/views/accounts/transferRecord/index.vue')
      },
      {
        path: 'setting',
        name: 'AccountsTransferSetting',
        meta: {
          title: '转账设置',
          noCache: true
        },
        component: () => import('@/views/accounts/transferManage/setting.vue')
      },
      {
        path: 'invoiceDesc',
        name: 'AccountsInvoiceDesc',
        meta: {
          title: '发票说明',
          noCache: true
        },
        component: () => import('@/views/accounts/invoiceDesc/index.vue')
      },
      {
        path: 'receipt',
        name: 'AccountsReceipt',
        meta: {
          title: '发票列表',
          noCache: true
        },
        component: () => import('@/views/accounts/receipt/index.vue')
      },
      {
        path: 'settings',
        name: 'AccountsSetting',
        meta: {
          title: '转账设置',
          noCache: true
        },
        component: () => import('@/views/accounts/settings/index.vue')
      },
      {
        path: 'zoneAgent/settlementReview',
        name: 'SettlementReview',
        meta: {
          title: '结算审核',
          noCache: true
        },
        component: () => import('@/views/accounts/zoneAgent/settlementReview.vue')
      },
      {
        path: 'zoneAgent/settlementApply',
        name: 'SettlementApply',
        meta: {
          title: '申请结算',
          noCache: true
        },
        component: () => import('@/views/accounts/zoneAgent/settlementApply.vue')
      },
      {
        path: 'zoneAgent/settlementAccount',
        name: 'SettlementAccount',
        meta: {
          title: '结算账号',
          noCache: true
        },
        component: () => import('@/views/accounts/zoneAgent/settlementAccount.vue')
      },
      {
        path: 'zoneAgent/commissionRecord',
        name: 'CommissionRecord',
        meta: {
          title: '提成流水',
          noCache: true
        },
        component: () => import('@/views/accounts/zoneAgent/commissionRecord.vue')
      },
      {
        path: 'deliverymanExtract',
        name: 'DeliverymanExtract',
        meta: {
          title: '配送员提现',
          noCache: true
        },
        component: () => import('@/views/accounts/deliverymanExtract/index.vue')
      },
      {
        path: 'deliverySettlement',
        name: 'DeliverySettlement',
        meta: {
          title: '配送员流水',
          noCache: true
        },
        component: () => import('@/views/accounts/deliverySettlement/index.vue')
      }
    ]
  }

export default accountsRouter;
